/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAuthenticationToken
 */
export interface PostAuthenticationToken {
    /**
     * The grant type for this flow. Can be authorization-code or refresh-token.
     * @type {string}
     * @memberof PostAuthenticationToken
     */
    grantType?: PostAuthenticationTokenGrantTypeEnum;
    /**
     * This is the autorization code the user received in the query string. In this case the **grant_type** MUST be **authorization_code**
     * @type {string}
     * @memberof PostAuthenticationToken
     */
    code?: string;
    /**
     * In this case the **grant_type** MUST be **refresh_token**
     * @type {string}
     * @memberof PostAuthenticationToken
     */
    refreshToken?: string;
}


/**
 * @export
 */
export const PostAuthenticationTokenGrantTypeEnum = {
    AuthorizationCode: 'authorization-code',
    RefreshToken: 'refresh-token'
} as const;
export type PostAuthenticationTokenGrantTypeEnum = typeof PostAuthenticationTokenGrantTypeEnum[keyof typeof PostAuthenticationTokenGrantTypeEnum];


/**
 * Check if a given object implements the PostAuthenticationToken interface.
 */
export function instanceOfPostAuthenticationToken(value: object): value is PostAuthenticationToken {
    return true;
}

export function PostAuthenticationTokenFromJSON(json: any): PostAuthenticationToken {
    return PostAuthenticationTokenFromJSONTyped(json, false);
}

export function PostAuthenticationTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAuthenticationToken {
    if (json == null) {
        return json;
    }
    return {
        
        'grantType': json['grant-type'] == null ? undefined : json['grant-type'],
        'code': json['code'] == null ? undefined : json['code'],
        'refreshToken': json['refresh-token'] == null ? undefined : json['refresh-token'],
    };
}

export function PostAuthenticationTokenToJSON(json: any): PostAuthenticationToken {
    return PostAuthenticationTokenToJSONTyped(json, false);
}

export function PostAuthenticationTokenToJSONTyped(value?: PostAuthenticationToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grant-type': value['grantType'],
        'code': value['code'],
        'refresh-token': value['refreshToken'],
    };
}

